<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
    <div ref="invoiceSection">
      <div v-if="hasFieldErrors('dataForm.data.duplicate')" class="bs-callout bs-callout-danger bg-danger bs3-margin-bottom30">
        <h4>Duplicate invoice?</h4>
        <p v-for="error in getFieldErrors('dataForm.data.duplicate')" :key="error">{{ error }}</p>
        <p>{{'dictionary.invoice.duplicate.confirmation' | i18nText(pDictionary)}}</p>
        <div class="checkbox">
          <label class="bs3-label">
            <input type="checkbox" name="dataForm.data.duplicateAcknowledged"
                   v-model="invoice.duplicateAcknowledged" value="true"> {{'dictionary.invoice.duplicate.acknowledge' | i18nText(pDictionary)}}
          </label>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-3">
          <!--
         - DATE
         --->
          <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.dateText')}]">
            <div v-if="hasFieldErrors('dataForm.data.dateText')">
              <span v-for="error in getFieldErrors('dataForm.data.dateText')" class="help-block" :key="error">{{ error }}</span>
            </div>
            <label v-else :for="'invoice_DateText'">
              <span v-show="invoiceDateRequired" class="required">*</span> {{ pDictionary['dictionary.invoice.date'] }}:
            </label>
            <div class="input-group">
              <span class="input-group-addon"><i class="fa-light fa-calendar"></i></span>
              <input ref="dateText"
                     type="text"
                     :id="'invoice_DateText'"
                     :name="'dataForm.data.dateText'"
                     v-model="invoice.dateText"
                     @change="onInvoiceDateChange"
                     :placeholder="pDictionary['dictionary.format.date.hint']"
                     class="form-control datepicker startDateText"
                     size="10" maxlength="10"
                     autocomplete="off">
            </div>
          </div>
        </div>
        <div class="col-xs-6">
          <!--
          - REFERENCE
          --->
          <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.reference')}]">
            <div v-if="hasFieldErrors('dataForm.data.reference')">
              <span v-for="error in getFieldErrors('dataForm.data.reference')" class="help-block" :key="error">{{ error }}</span>
            </div>
            <label v-else :for="'invoice_Reference'">
              <span v-show="invoiceReferenceRequired" class="required">*</span> {{ pDictionary['dictionary.invoice.reference'] }}:
            </label>
            <input type="text"
                   :id="'invoice_Reference'"
                   :name="'dataForm.data.reference'"
                   v-model="invoice.reference"
                   class="form-control "/>
          </div>
        </div>
        <div class="col-xs-3">
          <!--
            - PAYMENT DATE
            --->
          <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.paymentDeadlineDateText')}]">
            <div v-if="hasFieldErrors('dataForm.data.paymentDeadlineDateText')">
            <span v-for="error in getFieldErrors('dataForm.data.paymentDeadlineDateText')" class="help-block" :key="error">{{
                error
              }}</span>
            </div>
            <label v-else :for="'invoice_DateText'">
              <span v-show="paymentDeadlineDateRequired" class="required">*</span> {{
                pDictionary['dictionary.invoice.payment.deadline.date']
              }} <span class="nbdays-hint-default" v-html="invoice.paymentDeadlineDate.defaultNumberOfDaysToInvoicePaymentDeadlineDateHintText"></span>:
            </label>
            <div class="input-group">
              <span class="input-group-addon"><i class="fa-light fa-calendar"></i></span>
              <input ref="paymentDeadlineDateText"
                     type="text"
                     :id="'invoice_PaymentDeadlineDateText'"
                     :name="'dataForm.data.paymentDeadlineDateText'"
                     v-model="invoice.paymentDeadlineDateText"
                     @change="onInvoicePaymentDeadlineDateChange"
                     :placeholder="pDictionary['dictionary.format.date.hint']"
                     class="form-control datepicker paymentDeadlineDateText"
                     size="10" maxlength="10"
                     autocomplete="off">
            </div>
              <div class="nbdays-hint bs3-margin-top5" v-show="numberOfDaysToInvoicePaymentDeadlineDateHintVisible">
                  <span :class="paymentDeadlineDateClass"
                        v-html="invoice.paymentDeadlineDate.numberOfDaysToInvoicePaymentDeadlineDateHintText"></span>
              </div>
          </div>
        </div>
      </div>
  <fieldset class="bs3-margin-top">
    <legend><i class="fa-light fa-file-invoice-dollar"></i> {{ 'dictionary.invoice.description' | i18nText(pDictionary) }}</legend>
    <div>
      <div class="row">
        <div class="col-xs-3">
          <!--
           - MEDIA
           -->
          <media-select
              v-model="mediaId"
              :p-currencies="pCurrencies"
              :p-language="pLanguage"
              :p-dictionary="pDictionary"
              :p-urls="pUrls"
              :p-error-list="pErrorList"
              :p-src="pSrc"
              :p-src-id="pSrcId"
              p-error-key="dataForm.data.mediaRef"
              p-input-name="dataForm.data.mediaRef.id"
              p-select-container="#bsInvoiceSaveFormDialog"
              :p-required="true"
              :p-disabled="mediaSelectDisabled"
              :p-data-list-input="mediaDataListInput">
          </media-select>
        </div>
        <div class="col-xs-3">
          <!--
          - MEDIA FORMAT
          -->
          <media-format-select
              v-model="mediaFormatId"
              :p-currencies="pCurrencies"
              :p-language="pLanguage"
              :p-dictionary="pDictionary"
              :p-urls="pUrls"
              :p-error-list="pErrorList"
              :p-src="pSrc"
              :p-src-id="pSrcId"
              p-error-key="dataForm.data.mediaFormatRef"
              p-input-name="dataForm.data.mediaFormatRef.id"
              p-select-container="#bsInvoiceSaveFormDialog"
              :p-required="false"
              :p-disabled="mediaFormatSelectDisabled"
              :p-data-list-input="mediaFormatDataListInput">
          </media-format-select>
        </div>
        <div class="col-xs-6">
          <!--
          - PERIOD
          --->
          <invoice-save-form-invoice-section-period
              :p-currencies="pCurrencies"
              :p-language="pLanguage"
              :p-dictionary="pDictionary"
              :p-urls="pUrls"
              :p-error-list="pErrorList"
              :p-src="pSrc"
              :p-src-id="pSrcId"
              v-model="invoice.period"
              :p-min-date="invoice.periodMinDateText"
              :p-max-date="invoice.periodMaxDateText"
              :p-read-only="invoicePeriodDisabled">
          </invoice-save-form-invoice-section-period>
        </div>
      </div>

      <!--
       - INVOCE COST
       -->
          <table id="costDetailTable" class="table bs3-vertical-center bs3-margin-top bs3-margin-bottom-reset">
            <thead>
              <tr>
                <td class="bs3-padding-left-reset">
                  <select v-if="currencySelectVisible" ref="currencySelect" name="dataForm.data.currencyRef.id" v-model="currencyId" class="form-control selectpicker" @change="onChange('NET_COST')">
                    <option v-for="currency in pCurrencies"
                            :key="currency.id"
                            :value="currency.id">{{currency.name}}</option>
                  </select>
                </td>
                <td></td>
                <td class="text-right width250Pixels"><small>{{ 'dictionary.media.cost.planned' | i18nText(pDictionary) }}</small>
                  <i class="fa-light fa-circle-question bs3-margin-left3" aria-hidden="true" data-toggle="tooltip"
                     data-container="body" data-placement="top" :title="pDictionary['dictionary.media.cost.planned.hint']"></i></td>
                <td class="text-right width150Pixels"><small>{{ 'dictionary.media.cost.actual' | i18nText(pDictionary) }}</small>
                  <i class="fa-light fa-circle-question bs3-margin-left3" aria-hidden="true" data-toggle="tooltip"
                     data-container="body" data-placement="top" :title="pDictionary['dictionary.media.cost.actual.hint']"></i></td>
                <td></td>
                <td class="text-right width150Pixels"><span v-show="invoicedCostRequired" class="required">*</span> <small>{{ 'dictionary.media.cost.invoiced' | i18nText(pDictionary) }}</small>
                  <i class="fa-light fa-circle-question bs3-margin-left3" aria-hidden="true" data-toggle="tooltip"
                     data-container="body" data-placement="top" :title="pDictionary['dictionary.media.cost.invoiced.hint']"></i></td>
              </tr>
            </thead>
            <tbody>
            <!--
            - NET
            --->
            <tr :class="['table-borderless-top', 'total', {'has-error danger': hasFieldErrors('dataForm.data.actualNetCost.amountText')}]">
              <th>
                <span>{{ pDictionary['dictionary.media.cost.net'] }}</span>
              </th>
              <td></td>
              <td class="text-right text-muted">{{ invoiceCostInfo.plannedNetCostText | money(pCurrencies, currencyId) | emptyToDash }}</td>
              <td class="text-right text-muted">{{ invoiceCostInfo.actualNetCostText | money(pCurrencies, currencyId) | emptyToDash }}</td>
              <td></td>
              <td class="text-right width150Pixels">
                <div class="input-group">
                  <span class="input-group-addon bs3-padding-x7" id="basic-addon1"><i class="fa-light fa-lock fa-xs"></i></span>
                  <input type="text"
                         :id="'invoice_actualNetCost_amountText'"
                         :name="'dataForm.data.actualNetCost.amountText'"
                         v-model="invoice.actualNetCost.amountText"
                         @change="onChange('NET_COST')"
                         :placeholder="'0.00' | money(pCurrencies, currencyId)"
                         class="itemNetCost form-control text-right"/>
                </div>
                <span v-for="error in getFieldErrors('dataForm.data.actualNetCost.amountText')"
                      class="help-block" :key="error">{{ error }}</span>
              </td>
            </tr>
            <!--
            - TAXES
            --->
            <tr v-if="pTaxEnabled" v-for="(taxCost, taxIndex) in invoice.actualTaxCostList" :key="taxIndex"
                :class="[{'has-error danger': hasFieldErrors('dataForm.data.actualTaxCostText['+taxIndex+']')}, {'table-borderless-top': taxIndex > 0}]">
              <th>
                <a href="#" class="btn btn-default btn-sm removeTax bs3-margin-right5" @click.prevent="onRemoveTax(taxIndex)">
                  <i class="fa-light fa-trash-alt"></i>
                </a>
                <span>{{ taxCost.ref.name }}</span>
                <span v-for="error in getFieldErrors('dataForm.data.actualTaxCostList['+taxIndex+']')" class="help-block"
                      :key="error">{{ error }}</span>
                <input type="hidden"
                       :name="'dataForm.data.actualTaxCostList[' + taxIndex + '].ref.id'"
                       v-model="invoice.actualTaxCostList[taxIndex].ref.id"/>
              </th>
              <td></td>
              <td class="text-right text-muted"></td>
              <td class="text-right text-muted"></td>
              <td class="width100Pixels">
                <p class="form-control-static text-right">{{ invoice.actualTaxCostList[taxIndex].rateText | percent(pDictionary) }}</p>
              </td>
              <td class="text-right width150Pixels">
                <input type="text"
                       :id="'invoice_ActualTaxCostList' + taxIndex + 'amountText'"
                       :name="'dataForm.data.actualTaxCostList[' + taxIndex + '].amountText'"
                       v-model="invoice.actualTaxCostList[taxIndex].amountText"
                       @change="onChange('TAX_COST')"
                       :placeholder="'0.00' | money(pCurrencies, currencyId)"
                       class="itemNetCost form-control text-right" readonly/>
              </td>
            </tr>
            <tr v-if="pTaxEnabled" :class="[{'table-borderless-top': invoice.actualTaxCostList}]">
              <td v-if="addableTaxList.length > 0" class="bs3-padding-top-reset">
                <div class="btn-group">
                  <button type="button" class="btn btn-link bs3-padding-left-reset dropdown-toggle" data-toggle="dropdown"
                          aria-haspopup="true" aria-expanded="false">
                    <i class="fa-light fa-plus" aria-hidden="true"></i> Add tax <span class="caret"></span>
                  </button>
                  <ul class="dropdown-menu">
                    <li v-for="taxRef in addableTaxList" :key="taxRef.id">
                      <a href="#" class="addTax" :data-tax-id="taxRef.id" @click="onAddTax(taxRef)">{{ taxRef.name }}</a>
                    </li>
                  </ul>
                </div>
              </td>
              <td class="text-right text-muted">
                <ul v-if="invoice.plannedTaxRefs.length > 0" class="list-unstyled list-inline-csv bs3-margin-bottom-reset">
                  <li v-for="taxRef in invoice.plannedTaxRefs" :key="taxRef.id">{{taxRef.name}} ({{taxRef.params.plannedTaxRate | percent(pDictionary) | emptyToDash}})</li>
                </ul>
              </td>
              <td class="text-right text-muted">{{ invoiceCostInfo.plannedTaxCostText | money(pCurrencies, currencyId) | emptyToDash }}</td>
              <td class="text-right text-muted">{{ invoiceCostInfo.actualTaxCostText | money(pCurrencies, currencyId) | emptyToDash }}</td>
              <td colspan="2"></td>
            </tr>
            <!--
            - TOTAL COST VENDOR
            --->
            <tr v-show="vendorCostVisible" :class="['total', {'has-error danger': hasFieldErrors('dataForm.data.actualTotalVendorCost.amountText')}]">
              <th>
                <span v-if="pCommissionEnabled"
                      :inner-html.prop="pDictionary['dictionary.media.cost.total.vendor.html'] | i18nparams(0, '<br/>')"></span>
                    <span v-else>{{ pDictionary['dictionary.media.cost.total'] }}</span>
                    <span v-for="error in getFieldErrors('dataForm.data.actualTotalVendorCost.amountText')" class="help-block"
                          :key="error">{{ error }}</span>
              </th>
              <td></td>
              <td class="text-right text-muted">{{ invoiceCostInfo.plannedTotalVendorCostText | money(pCurrencies, currencyId) | emptyToDash }}</td>
              <td class="text-right text-muted">{{ invoiceCostInfo.actualTotalVendorCostText | money(pCurrencies, currencyId) | emptyToDash }}</td>
              <td></td>
              <td class="text-right width150Pixels">
                <input type="text"
                       :id="'invoice_actualTotalVendorCost_amountText'"
                       :name="'dataForm.data.actualTotalVendorCost.amountText'"
                       v-model="invoice.actualTotalVendorCost.amountText"
                       @change="onChange('TOTAL_VENDOR_COST')"
                       :placeholder="'0.00' | money(pCurrencies, currencyId)"
                       class="itemNetCost form-control text-right"/>
              </td>
            </tr>
            <!--
            - COMMISSION
            --->
            <tr v-show="pCommissionEnabled"
                :class="[{'has-error danger': hasFieldErrors('dataForm.data.actualCommissionCost.amountText')}]">
              <th>
                <span>{{ pDictionary['dictionary.media.cost.commission'] }}:</span>
                <span v-for="error in getFieldErrors('dataForm.data.actualCommissionCost.amountText')" class="help-block"
                      :key="error">{{ error }}</span>
              </th>
              <td class="text-right text-muted"></td>
              <td class="text-right text-muted"><small v-show="invoiceCostInfo.plannedCommissionRateText" class="bs3-margin-right5">({{invoiceCostInfo.plannedCommissionRateText | percent(pDictionary) | emptyToDash}})</small> {{ invoiceCostInfo.plannedCommissionCostText | money(pCurrencies, currencyId) | emptyToDash }}</td>
              <td class="text-right text-muted">{{ invoiceCostInfo.actualCommissionCostText | money(pCurrencies, currencyId) | emptyToDash }}</td>
              <td class="text-right width100Pixels">
                <div class="input-group">
                  <span class="input-group-addon bs3-padding-x7" id="basic-addon1"><i class="fa-light fa-lock fa-xs"></i></span>
                  <input type="text"
                         :id="'invoice_actualCommissionCost_rateText'"
                         :name="'dataForm.data.actualCommissionCost.rateText'"
                         v-model="invoice.actualCommissionCost.rateText"
                         @change="onChange('COMMISSION_RATE')"
                         :placeholder="'0' | percent(pDictionary)"
                         class="itemNetCost form-control text-right"/>
                </div>
              </td>
              <td class="text-right width150Pixels">
                <input type="text"
                       :id="'invoice_actualCommissionCost_amountText'"
                       :name="'dataForm.data.actualCommissionCost.amountText'"
                       v-model="invoice.actualCommissionCost.amountText"
                       @change="onChange('COMMISSION_COST')"
                       :placeholder="'0.00' | money(pCurrencies, currencyId)"
                       class="itemNetCost form-control text-right"/>
              </td>

            </tr>
            <!--
           - COST FEE
           --->
            <tr v-for="(costFee, costFeeIndex) in invoice.invoicedCostFees" :key="costFeeIndex"
                :class="[{'has-error danger': hasFieldErrors('dataForm.data.invoicedCostFeeText['+costFeeIndex+']')}, {'table-borderless-top': taxIndex > 0}]">
              <th colspan="2">
<!--                <a href="#" class="btn btn-default btn-sm removeTax bs3-margin-right5" @click.prevent="onRemoveTax(costFeeIndex)">-->
<!--                  <i class="fa-light fa-trash-alt"></i>-->
<!--                </a>-->
                <span class="bs3-margin-right3"><i :class="getFeeIcon(costFee)" data-toggle="tooltip" data-container="body" :title="getFeeHint(costFee)"></i></span>
                <span>{{ costFee.ref.name }}</span>
                <span v-for="error in getFieldErrors('dataForm.data.invoicedCostFees['+costFeeIndex+']')" class="help-block"
                      :key="error">{{ error }}</span>
                <input type="hidden"
                       :name="'dataForm.data.invoicedCostFees[' + costFeeIndex + '].ref.id'"
                       v-model="invoice.invoicedCostFees[costFeeIndex].ref.id"/>
              </th>
              <td class="text-right text-muted"><small v-show="invoiceCostInfo.plannedCostFeeRateTextById[costFee.ref.id]" class="bs3-margin-right5">({{invoiceCostInfo.plannedCostFeeRateTextById[costFee.ref.id] | percent(pDictionary) | emptyToDash}})</small> {{ invoiceCostInfo.plannedCostFeeCostTextById[costFee.ref.id] | money(pCurrencies, currencyId) | emptyToDash }}</td>
              <td class="text-right text-muted"><small v-show="invoiceCostInfo.actualCostFeeCostTextById[costFee.ref.id]" class="bs3-margin-right5">({{invoiceCostInfo.actualCostFeeRateTextById[costFee.ref.id] | percent(pDictionary) | emptyToDash}})</small> {{ invoiceCostInfo.actualCostFeeCostTextById[costFee.ref.id] | money(pCurrencies, currencyId) | emptyToDash }}</td>
              <td class="width100Pixels">
                <div class="input-group" v-if="refHelpers.getRefParam(costFee.ref, 'fixedRate', 'false') === 'true'">
                  <span class="input-group-addon bs3-padding-x7" id="basic-addon1"><i class="fa-light fa-lock fa-xs"></i></span>
                  <input type="text"
                         :id="'invoice_invoicedCostFees_' + costFeeIndex + '_rateText'"
                         :name="'dataForm.data.invoicedCostFees[' + costFeeIndex + '].rateText'"
                         v-model="invoice.invoicedCostFees[costFeeIndex].rateText"
                         @change="onChange('CLIENT_FEE_RATE', costFee.ref.id)"
                         :placeholder="'0' | percent(pCurrencies, currencyId)"
                         class="itemNetCost form-control text-right" />
                </div>
                <input v-else type="text"
                       :id="'invoice_invoicedCostFees_' + costFeeIndex + '_rateText'"
                       :name="'dataForm.data.invoicedCostFees[' + costFeeIndex + '].rateText'"
                       v-model="invoice.invoicedCostFees[costFeeIndex].rateText"
                       @change="onChange('CLIENT_FEE_RATE', costFee.ref.id)"
                       :placeholder="'0' | percent(pCurrencies, currencyId)"
                       class="itemNetCost form-control text-right" />
              </td>
              <td class="text-right width150Pixels">
                <div class="input-group" v-if="refHelpers.getRefParam(costFee.ref, 'fixedRate', 'false') === 'false'">
                  <span class="input-group-addon bs3-padding-x7" id="basic-addon1"><i class="fa-light fa-lock fa-xs"></i></span>
                  <input type="text"
                         :id="'invoice_invoicedCostFees' + costFeeIndex + 'amountText'"
                         :name="'dataForm.data.invoicedCostFees[' + costFeeIndex + '].amountText'"
                         v-model="invoice.invoicedCostFees[costFeeIndex].amountText"
                         @change="onChange('CLIENT_FEE_COST', costFee.ref.id)"
                         :placeholder="'0.00' | money(pCurrencies, currencyId)"
                         class="itemNetCost form-control text-right" />
                </div>
                <input v-else type="text"
                       :id="'invoice_invoicedCostFees' + costFeeIndex + 'amountText'"
                       :name="'dataForm.data.invoicedCostFees[' + costFeeIndex + '].amountText'"
                       v-model="invoice.invoicedCostFees[costFeeIndex].amountText"
                       @change="onChange('CLIENT_FEE_COST', costFee.ref.id)"
                       :placeholder="'0.00' | money(pCurrencies, currencyId)"
                       class="itemNetCost form-control text-right" />
              </td>

            </tr>
            <!--
            - TOTAL COST CLIENT
            --->
            <tr v-show="clientCostVisible"
                :class="['total', {'has-error danger': hasFieldErrors('dataForm.data.actualTotalClientCost.amountText')}]">
              <th>
            <span v-if="pCommissionEnabled"
                  :inner-html.prop="pDictionary['dictionary.media.cost.total.client.html'] | i18nparams(0, '<br/>')"></span>
                <span v-else>{{ pDictionary['dictionary.media.cost.total'] }}</span>
              </th>
              <td></td>
              <td class="text-right text-muted">{{ invoiceCostInfo.plannedTotalClientCostText | money(pCurrencies, currencyId) | emptyToDash }}</td>
              <td class="text-right text-muted">{{ invoiceCostInfo.actualTotalClientCostText | money(pCurrencies, currencyId) | emptyToDash }}</td>
              <td></td>
              <td class="text-right width150Pixels">
                <input type="text"
                       :id="'invoice_actualTotalClientCost_amountText'"
                       :name="'dataForm.data.actualTotalClientCost.amountText'"
                       v-model="invoice.actualTotalClientCost.amountText"
                       @change="onChange('TOTAL_CLIENT_COST')"
                       :placeholder="'0.00' | money(pCurrencies, currencyId)"
                       class="itemNetCost form-control text-right"/>
                <span v-for="error in getFieldErrors('dataForm.data.actualTotalClientCost.amountText')" class="help-block"
                      :key="error">{{ error }}</span>
              </td>
            </tr>
            </tbody>
          </table>
    </div>
  </fieldset>
      <!--
       - INVOCE SPLIT COST
       -->
      <fieldset v-if="invoice.actualOrganizationCostList.length > 1" class="bs3-margin-top30">
        <legend><i class="fa-light fa-random" aria-hidden="true"></i> {{ pDictionary['dictionary.media.insertion.cost.split'] }}</legend>
        <div>
          <table id="organizationSplitTable" class="table bs3-vertical-center bs3-margin-bottom-reset">
            <thead>
            <tr>
              <td>
                <div>{{ pDictionary['dictionary.media.insertion.cost.split.total'] }}</div>
              </td>
              <td class="text-right width250Pixels"></td>
              <td class="text-right width150Pixels"></td>
              <td>{{ pDictionary['dictionary.media.insertion.cost.split.percent'] }}</td>
              <td class="text-right bs3-padding-right20">{{ invoice.actualTotalClientCost.amountText | money(pCurrencies, currencyId) }}</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(organization, orgIndex) in invoice.actualOrganizationCostList" :key="organization.ref.id"
                :class="[{'has-error danger': hasFieldErrors('dataForm.data.actualOrganizationCostList[' + orgIndex + ']')}, {'cost-separator': orgIndex === 0}]">
              <th>
                <span>{{ organization.ref.name }}</span>
                <input type="hidden"
                       :name="'dataForm.data.actualOrganizationCostList[' + orgIndex + '].ref.id'"
                       v-model="invoice.actualOrganizationCostList[orgIndex].ref.id"/>
              </th>
              <td class="width250Pixels text-right text-muted">{{ organizationPlannedTotalClientCostText(organization.ref.id) | money(pCurrencies, currencyId) | emptyToDash }}</td>
              <td class="width150Pixels text-right text-muted">{{ organizationActualTotalClientCostText(organization.ref.id) | money(pCurrencies, currencyId) | emptyToDash }}</td>
              <td class="width100Pixels">
                <input type="text"
                       :id="'invoice_actualOrganizationCostList' + orgIndex + '_rateText'"
                       :name="'dataForm.data.actualOrganizationCostList[' + orgIndex + '].rateText'"
                       v-model="invoice.actualOrganizationCostList[orgIndex].rateText"
                       @change="onChange('ORGANIZATION_COST_RATIO')"
                       :placeholder="'0' | percent(pDictionary)"
                       class="actualOrganizationCostRatio form-control"/>
              </td>
              <td class="text-right width150Pixels">
                <input type="text"
                       :id="'invoice_actualOrganizationCostList' + orgIndex + '_amountText'"
                       :name="'dataForm.data.actualOrganizationCostList[' + orgIndex + '].amountText'"
                       v-model="invoice.actualOrganizationCostList[orgIndex].amountText"
                       @change="onChange('ORGANIZATION_COST')"
                       :placeholder="'0.00' | money(pCurrencies, currencyId)"
                       class="actualOrganizationCost form-control text-right"/>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr :class="[{'has-error danger': hasFieldErrors('dataForm.data.actualOrganizationCostList')}, 'cost-separator']">
              <td colspan="3">
                <span>{{ pDictionary['dictionary.media.insertion.cost.split.remain'] }}</span>
                <span v-for="error in getFieldErrors('dataForm.data.actualOrganizationCostList')"
                      class="help-block" :key="error">{{ error }}</span>
              </td>
              <td>
                <a href="#" class="btn btn-sm btn-default" data-toggle="tooltip"
                   data-container="body" data-placement="top" :title="pDictionary['dictionary.media.insertion.cost.distribute']"
                   @click.prevent="onDistribute">
                  <i class="fa-light fa-random" aria-hidden="true"></i></a>
              </td>
              <td class="text-right bs3-padding-right20">{{ invoice.remainingActualCostToDistributeText | money(pCurrencies, currencyId) }}</td>
            </tr>
            </tfoot>
          </table>
        </div>
      </fieldset>
      <div v-else-if="invoice.actualOrganizationCostList.length === 1">
        <input type="hidden"
               :name="'dataForm.data.actualOrganizationCostList[0].ref.id'"
               v-model="invoice.actualOrganizationCostList[0].ref.id"/>
        <input type="hidden"
               :name="'dataForm.data.actualOrganizationCostList[0].rateText'"
               v-model="invoice.actualOrganizationCostList[0].rateText"/>
        <input type="hidden"
               :name="'dataForm.data.actualOrganizationCostList[0].amountText'"
               v-model="invoice.actualOrganizationCostList[0].amountText"/>
      </div>

      <!--
      - PAYMENT SECTION
      -->
      <invoice-save-form-payment-section      :p-currencies="pCurrencies"
                                              :p-language="pLanguage"
                                         :p-dictionary="pDictionary"
                                         :p-urls="pUrls"
                                         :p-error-list="pErrorList"
                                         :p-src="pSrc"
                                         :p-src-id="pSrcId"
                                         :p-invoice.sync="invoice"/>

      <!--
 - FILES
 -->
      <file-list-section
          :p-currencies="pCurrencies"
          :p-language="pLanguage"
          :p-dictionary="pDictionary"
          :p-urls="pUrls"
          :p-error-list="pErrorList"
          :p-src="pSrc"
          :p-src-id="pSrcId"
          p-parent-id="#bsInvoiceSaveFormDialog"
          p-data-form-input-name="dataForm"
          :p-file-list-drop-zone-enabled="true"
          :p-file-list-ref="invoice.fileListRef">
      </file-list-section>
    </div>
</template>

<script>
import stringhelpers from "@/helpers/string-helpers"
import refHelpers from '@/helpers/ref-helpers'
import InvoiceSaveFormInvoiceSectionPeriod from "@/components/modules/accounting-module/invoice/form/save/InvoiceSaveFormInvoiceSectionPeriod";
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import InvoiceSaveFormPaymentSection from "@/components/modules/accounting-module/invoice/form/save/InvoiceSaveFormPaymentSection";
import MediaSelect from "@/components/media/media/MediaSelect";
import MediaFormatSelect from "@/components/media/format/MediaFormatSelect";
import FileListSection from "@/components/modules/file-module/file/section/FileListSection";

export default {
  name: "InvoiceSaveFormInvoiceSection",
  components: {InvoiceSaveFormPaymentSection, InvoiceSaveFormInvoiceSectionPeriod, MediaSelect, MediaFormatSelect, FileListSection},
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pCurrencies: Array,
    pLanguage: String,
    pDictionary: Object,
    pUrls: Object,
    pErrorList: {
      type: Object,
      default: function () {
        return {}
      }
    },
    pSrc: String,
    pSrcId: String,
    pInvoice: Object,
    pTaxEnabled: Boolean,
    pCommissionEnabled: Boolean,
    pValidatePaymentDeadlineDateEnabled: Boolean,
    pAllTaxes: Array
  },
  data: function () {
    return {
      invoice: this.pInvoice,
      currencyId: refHelpers.getRefId(this.pInvoice.currencyRef, null),
      invoiceCostInfo: this.pInvoice.invoiceCostInfo,
      mediaId: refHelpers.getRefId(this.pInvoice.mediaRef, null),
      mediaFormatId: refHelpers.getRefId(this.pInvoice.mediaFormatRef, null),
      errorList: []
    }
  },
  methods: {
    getFeeIcon: function(costFee) {
      if(costFee.ref.params.fixedRate === 'true') {
        return 'fa-light fa-badge-percent';
      } else {
        return 'fa-light fa-badge-dollar';
      }
    },
    getFeeHint: function(costFee) {
      if(costFee.ref.params.fixedRate === 'true') {
        return this.pCommissionEnabled ? this.pDictionary['dictionary.cost.fee.type.fixed-rate.hint.client'] : this.pDictionary['dictionary.cost.fee.type.fixed-rate.hint'];
      } else {
        return this.pDictionary['dictionary.cost.fee.type.fixed-cost.hint'];
      }
    },
    organizationPlannedTotalClientCostText: function(organizationId) {
      let costInfo = this.invoiceCostInfo != null && this.invoiceCostInfo.byOrganizationId != null ? this.invoiceCostInfo.byOrganizationId[organizationId] : null;
      return costInfo ? costInfo.plannedTotalClientCostText : null;
    },
    organizationActualTotalClientCostText: function(organizationId) {
      let costInfo = this.invoiceCostInfo != null && this.invoiceCostInfo.byOrganizationId != null ? this.invoiceCostInfo.byOrganizationId[organizationId] : null;
      return costInfo ? costInfo.actualTotalClientCostText : null;
    },
    onChange: function (initiatedByField, fieldRefId) {
      this.$emit('invoice-updated', this.invoice, initiatedByField, fieldRefId);
    },
    onAddTax: function (taxRef) {
      this.$emit('invoice-add-tax', this.invoice, taxRef.id);
    },
    onRemoveTax: function (taxIndex) {
      this.$emit('invoice-remove-tax', this.invoice, taxIndex);
    },
    onDistribute: function () {
      this.$emit('invoice-distribute-cost-organization', this.invoice);
    },
    onInvoiceUpdated: function () {
      this.$emit('invoice-updated', this.invoice);
    },
    onInvoiceDateChange: function() {
       this.updateInvoiceDueDate(this.mediaId, this.invoice.dateText, '')
    },
     onInvoicePaymentDeadlineDateChange: function() {
        this.updateInvoiceDueDate(this.mediaId, this.invoice.dateText, this.invoice.paymentDeadlineDateText)
     },
    hasFieldErrors: function (name) {
      if(name in this.pErrorList)
      {
        return !$.isEmptyObject(this.pErrorList[name]);
      }
    },
    getFieldErrors: function (name) {
      if(name in this.pErrorList)
      {
        return this.pErrorList[name];
      }
      return [];
    },
    updateInvoiceDueDate: function(mediaId, invoiceDateText, invoicePaymentDeadlineDateText) {
       let _component = this;
       $.ajax({
                 type: "POST",
                 url: "/mediaplan/app/endpoints/json-api/medias/invoice-payment-deadline-date",
                 data: JSON.stringify({
                                         "mediaId": mediaId || -1,
                                         "invoiceDateText": invoiceDateText,
                                         "invoicePaymentDeadlineDateText": invoicePaymentDeadlineDateText
                                      }),
                 headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                 }
              }).done(function (invoicePaymentDeadlineDateJsonData) {
          _component.invoice.paymentDeadlineDate = invoicePaymentDeadlineDateJsonData;
          _component.invoice.paymentDeadlineDateText = invoicePaymentDeadlineDateJsonData.invoicePaymentDeadlineDateText;
       });
    },
    updateInvoiceCosts: function(currencyId) {
      let _component = this;
      _component.invoiceCostInfo = {};
      $.ajax({
               type: "GET",
               url: "/mediaplan/app/endpoints/json-api/invoices/form/cost-info",
               data: {
                 invoiceId: _component.invoice.id || -1,
                 currencyId: currencyId
               },
               headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
               }
             }).done(function (invoiceCostInfo) {
        _component.invoiceCostInfo = invoiceCostInfo;
      });
    }
  },
  computed: {
    vendorCostVisible: function() {
      return this.pTaxEnabled || this.pCommissionEnabled;
    },
    clientCostVisible: function() {
      return this.pCommissionEnabled || this.invoice.invoicedCostFees.length > 0;
    },
    refHelpers()
    {
      return refHelpers
    },
    numberOfDaysToInvoicePaymentDeadlineDateHintVisible: function() {
        return this.invoice.paymentDeadlineDate.numberOfDaysToInvoicePaymentDeadlineDate !== -1;
    },
     paymentDeadlineDateClass: function() {
        if(this.invoice.paymentDeadlineDate.invoicePaymentLate)
           return 'text-warning';
        return 'text-muted';
     },
    addableTaxList: function () {
      let usedTaxIds = [];
      this.invoice.actualTaxCostList.forEach(function (actualTaxCost) {
        if(actualTaxCost.ref)
        {
          usedTaxIds.push(actualTaxCost.ref.id);
        }
      });
      return this.pAllTaxes.filter(function (tax) {
        return !usedTaxIds.includes(tax.id)
      });
    },
    isIdValid: function () {
      return this.pInvoice.id !== undefined
             && this.pInvoice.id > 0;
    },
    hasMediaInsertion: function() {
      return refHelpers.isValidRef(this.pInvoice.mediaInsertionRef)
    },
    currencySelectVisible: function() {
      return !this.isIdValid && !this.hasMediaInsertion;
    },
    mediaSelectDisabled: function() {
      return false;
    },
    mediaDataListInput: function() {
      return {
        projectIds: [this.mediaPlanId || -1],
        campaignIds: [this.campaignId || null],
        organizationIds: this.organizationIds,
        groupBy: 'S-4' // MediaCategoryDefinition.TOKEN
      };
    },
    mediaFormatSelectDisabled: function() {
      return !refHelpers.isValidRefId(this.mediaId);
    },
    mediaFormatDataListInput: function() {
      return {
        mediaIds: [this.mediaId || -1]
      };
    },
    workflowStage: function() {
      return refHelpers.getRefParam(this.pInvoice.statusRef, 'workflowStage', 'EXPECTED');
    },
    invoiceDateRequired: function() {
      return this.workflowStage !== 'EXPECTED';
    },
    invoiceReferenceRequired: function() {
      return this.workflowStage !== 'EXPECTED';
    },
    paymentDeadlineDateRequired: function () {
      return this.pValidatePaymentDeadlineDateEnabled && this.workflowStage !== 'EXPECTED';
    },
    invoicePeriodDisabled: function() {
      return !this.invoice.allowedTo['UPDATE_INVOICE_PERIOD_DATES'];
    },
    invoicedCostRequired: function() {
      return this.workflowStage !== 'EXPECTED';
    },
  },
  watch: {
    pInvoice: function (val) {
      this.invoice = val;
    },
    currencyId: function(currencyId) {
      this.updateInvoiceCosts(currencyId);
    },
     mediaId: function(mediaId) {
        this.$emit('invoice-media-updated', mediaId);
        this.updateInvoiceDueDate(mediaId, this.invoice.dateText, '')
     },
     mediaFormatId: function(mediaFormatId) {
        this.$emit('invoice-media-format-updated', mediaFormatId);
     }
  },
  filters: {
    // TODO: Use mixin...
    safeReference: function (reference, dictionary) {
      if(!reference)
      {
        return dictionary['dictionary.invoice'];
      }
      return reference;
    },
    i18nparams: function (text, index, param) {
      if(!text)
      {
        return text;
      }
      else
      {
        return stringhelpers.replaceAll(text, '__' + index + '__', param);
      }
    },
    money: function (value, currencies, currencyId) {
      if(value) {
        let currency = currencies.find(c => c.id === currencyId);
        if(currency) {
          if(currency.symbolPosition === 'BEFORE') {
            return currency.symbol + " " + value;
          }
          return value + " " + currency.symbol;
        }
      }
      return '-';
    },
    percent: function (value, dictionary) {
      if(!value)
      {
        return '-';
      }
      else
      {
        let percentFormat = dictionary['dictionary.format.percent.digit.4'];
        return stringhelpers.replaceAll(percentFormat, '__0__', value);
      }
    },
    error: function (value, dictionary) {
      if(!value)
      {
        return '-';
      }
      else
      {
        let errorFormat = dictionary['dictionary.general.errors'];
        return stringhelpers.replaceAll(errorFormat, '__0__', value);
      }
    }
  },
  created: function () {
  },
  mounted: function () {
    let _component = this;

    // Init DateText.
    let $dateText = $(this.$refs.dateText);
    $dateText.initFromDatePicker(
        {
          dateElId: $dateText.attr('id'),
          linkDateElId: null,
          minDate: null,
          maxDate: null,
          bs3: true,
          f: function (selectedDate) {
            _component.$data.invoice.dateText = selectedDate;
            _component.$refs.dateText.dispatchEvent(new Event('change'));
          }, noWeekends: false
        });

    // Init PaymentDeadlineDateText.
    let $paymentDeadlineDateText = $(this.$refs.paymentDeadlineDateText);
    $paymentDeadlineDateText.initFromDatePicker(
        {
          dateElId: $paymentDeadlineDateText.attr('id'),
          linkDateElId: null,
          minDate: null,
          maxDate: null,
          bs3: true,
          f: function (selectedDate) {
            _component.$data.invoice.paymentDeadlineDateText = selectedDate;
            _component.$refs.paymentDeadlineDateText.dispatchEvent(new Event('change'));
          }, noWeekends: false
        });

    // Init currency select
    let $currencySelect = $(_component.$refs.currencySelect);
    $currencySelect.selectpicker();

    // Create the tooltips.
    let $invoiceSection = $(this.$refs.invoiceSection);
    $invoiceSection.find('[data-toggle="tooltip"]').tooltip();

    let $expected = $(_component.$refs.expected);
    $expected.bootstrapToggle();
    $expected.change(function() {
      _component.$data.invoice.expected = $expected.prop('checked');
    })
  },
  updated: function () {
    let _component = this;

    // refresh currency select.
    let $currencySelect = $(_component.$refs.currencySelect);
    $currencySelect.selectpicker('refresh');

    let $invoiceSection = $(_component.$refs.invoiceSection);
    $invoiceSection.find('[data-toggle="tooltip"]').tooltip();
  },
  destroyed: function () {
    let _component = this;

    // destroy currency select.
    let $currencySelect = $(_component.$refs.currencySelect);
    $currencySelect.selectpicker('destroy');

    // dEstroy the tooltips.
    let $invoiceSection = $(_component.$refs.invoiceSection);
    $invoiceSection.find('[data-toggle="tooltip"]').tooltip('destroy');

    let $expected = $(_component.$refs.expected);
    $expected.bootstrapToggle('destroy')
    $expected.off('change')
  }
}
</script>

<style scoped>

</style>